import { Box } from '@mui/material';
import AnimatedSkeleton from '@/TRC/components/PdfView/components/AnimatedSkeleton';

const PdfPageCanvas = ({ canvasRef, width, height, showSkeleton, linkOverlays = [], onPdfLinkClick }) => {
	return (
		<Box
			sx={{
				position: 'relative',
				width,
				height,
				border: '0.07rem solid #ccc',
				borderRadius: 1,
				overflow: 'hidden'
			}}
		>
			{showSkeleton ? (
				<AnimatedSkeleton variant="rectangular" width="100%" height="100%" />
			) : (
				<>
					<canvas ref={canvasRef} style={{ display: 'block' }} />
					{linkOverlays.map(link => {
						const commonStyles = {
							position: 'absolute',
							left: link.left,
							top: link.top,
							width: link.width,
							height: link.height,
							cursor: 'pointer',
							background: 'transparent',
							border: 0,
							padding: 0,
							zIndex: 2
						};

						if (link.url) {
							return (
								<Box
									key={link.id}
									component="a"
									href={link.url}
									target="_blank"
									rel="noopener noreferrer"
									aria-label="Open PDF link"
									sx={commonStyles}
								/>
							);
						}

						return (
							<Box
								key={link.id}
								component="button"
								type="button"
								aria-label="Go to PDF destination"
								onClick={() => onPdfLinkClick?.(link.dest)}
								sx={commonStyles}
							/>
						);
					})}
				</>
			)}
		</Box>
	);
};

export default PdfPageCanvas;
